/**
 * EditionAdminRoute — 외부 배포판의 **내용을 정하는 화면**을 지킨다.
 *
 * 통과 기준은 헤더의 `[내부용|외부용]` 탭이 보이는 사람과 **똑같다**(`useEdition().canSwitch`
 * — 전역 관리자 또는 라인업 매장 대표). 판정식을 새로 쓰지 않고 그 값을 그대로 읽는 이유가
 * 이 파일의 전부다: 미리보기로 "고객에게 이렇게 보인다"를 확인하는 사람과 그 내용을 정하는
 * 사람이 갈리면, 켜 놓고 확인할 수 없거나 확인만 하고 못 바꾸는 사람이 생긴다.
 *
 * ⚠️ GlobalAdminRoute 를 쓰지 않는다 — 라인업 매장 대표는 role 이 owner 라 그 문을 못 지난다.
 *    서버도 같은 이유로 requireAdmin 이 아니라 requireEditionAdmin 을 쓴다.
 */

import { Navigate, Outlet } from "react-router";
import { useEdition } from "../../context/EditionContext";

export default function EditionAdminRoute() {
  const { canSwitch, ready } = useEdition();

  // 신분이 확정되기 전에는 판단하지 않는다 — 프로필 도착 전엔 누구든 "전환 못 하는 사람"으로
  // 보이므로, 여기서 곧바로 튕기면 권한 있는 사람도 새로고침마다 쫓겨난다.
  if (!ready) return null;
  if (!canSwitch) return <Navigate to="/" replace />;

  return <Outlet />;
}
